import React, { Component } from 'react';
import { Icon } from 'antd';

export class NotAllow extends Component {
  render() {
    const { style } = this.props;
    return (
      <div style={style ? style : {}}>
        <h4><Icon type="warning" style={{ color: 'red', fontSize: 16 }} /> Bạn không được cấp quyền để truy cập nội dung này.</h4>
      </div>
    )
  }
}

export default NotAllow